module.exports = __webpack_public_path__ + "static/q9-2ea4177a056938f2ea527c3d144aeb8e.svg";